




















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import stepBar from "@/components/searchMember/stepBar.vue";

const giftCardModule = namespace("giftCard");

@Component({
	components: {
		stepBar,
	},
})
export default class SearchMember extends Vue {
	@giftCardModule.State("successInfo") successInfo!: any;
	infoEffectiveConditionLimit!: any;

	writeOffTime: any = "";
	active: number = 2;
	entityName: string = this.$global.tenantName;
	memberUsername: string = this.$global.uName;
	defaultImg: any = require("@/image/default.png");
	created() {
		let memberKeyword = this.$route.query.memberKeyword;
	}
	mounted() {
		this.$store.commit('retreatCoupon/setSelectStep', 3)
	}
	backIndex() {
		this.$router.push(`/home`);
	}
}
